<template>
  <v-menu right bottom>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon color="#B6C1CB">more_vert</v-icon>
      </v-btn>
    </template>

    <v-list class="my-vlist" dense>
      <v-list-item class="my-vlistitem">
        <v-list-item-title class="my-vlistitemtitle">
          <v-icon class="menu-icons">thumb_up</v-icon>Like
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="my-vlistitem">
        <v-list-item-title class="my-vlistitemtitle" @click="routeUser()">
          <v-icon class="menu-icons">account_circle</v-icon>User Profile
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="my-vlistitem">
        <v-list-item-title class="my-vlistitemtitle" @click="routeDiary()">
          <v-icon class="menu-icons">developer_board</v-icon>User Diary
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="my-vlistitem">
        <v-list-item-title class="my-vlistitemtitle" @click="routeStrategies()">
          <v-icon class="menu-icons">vpn_key</v-icon>User Strategies
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="my-vlistitem">
        <v-list-item-title class="my-vlistitemtitle" @click="routeTags()">
          <v-icon class="menu-icons">local_offer</v-icon>User Tags
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: ["record"],
  methods: {
    routeUser() {
      return this.$router.push({ path: "/user/" + this.record.user.username });
    },
    routeDiary() {
      return this.$router.push({
        path: "/journal/" + this.record.user.username
      });
    },
    routeStrategies() {
      return this.$router.push({
        name: "strategies",
        params: { name: this.record.user.username }
      });
    },
    routeTags() {
      return this.$router.push({
        name: "tags",
        params: { name: this.record.user.username }
      });
    }
  }
};
</script>

<style>
</style>